// REMIX HMR BEGIN
import * as __hmr__ from "remix:hmr";
if (import.meta) {
import.meta.hot = __hmr__.createHotContext(
//@ts-expect-error
"app/components/Label.tsx"
);
import.meta.hot.lastModified = "1743695663150.7148";
}
// REMIX HMR END

import * as RadixLabel from '@radix-ui/react-label'
import { style } from '~/utils/style'

export const Label = style(RadixLabel.Root, 'text-black')
